import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["d", "stroke-width"]
const _hoisted_3 = ["d", "stroke-width"]
const _hoisted_4 = ["x", "y", "text-anchor"]

import { PropType, computed } from 'vue';

const netcallSalmonColour = '#FF6666';


export default /*@__PURE__*/_defineComponent({
  __name: 'TagBox',
  props: {
  value: {
    type: String,
    required: true,
  },
  width: {
    type: Number,
    default: 65,
  },
  height: {
    type: Number,
    default: 36,
  },
  border: {
    type: Number,
    default: 1,
  },
  align: {
    type: String as PropType<'left' | 'middle'>,
    default: 'middle',
  },
},
  setup(__props) {

const props = __props;

const boxPath = computed(() => `M${props.width} 0 H0 V${props.height} H${props.width}`);
const arrowPath = computed(
  () => `M${props.width} ${props.height} L${widthWithArrow.value} ${props.height / 2} L${props.width} 0`,
);
const widthWithArrow = computed(() => props.width + 10);
const textBaseline = computed(() => props.height / 2 + props.border * 2);
const textX = computed(() => (props.align === 'left' ? 10 : props.width / 2));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    style: _normalizeStyle({ height: `${__props.height}px` })
  }, [
    (_openBlock(), _createElementBlock("svg", {
      class: "tag-box",
      xmlns: "http://www.w3.org/2000/svg",
      width: widthWithArrow.value,
      height: __props.height
    }, [
      _createElementVNode("path", {
        d: boxPath.value,
        fill: "none",
        stroke: netcallSalmonColour,
        "stroke-width": __props.border + 1
      }, null, 8, _hoisted_2),
      _createElementVNode("path", {
        d: arrowPath.value,
        fill: "none",
        stroke: netcallSalmonColour,
        "stroke-width": __props.border
      }, null, 8, _hoisted_3),
      _createElementVNode("text", {
        x: textX.value,
        y: textBaseline.value,
        "alignment-baseline": "middle",
        "text-anchor": __props.align
      }, _toDisplayString(__props.value), 9, _hoisted_4)
    ], 8, _hoisted_1))
  ], 4))
}
}

})